import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  HostListener,
  AfterViewInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { validationmethod } from "src/app/shared/models/validationmethod";
import { CommonService } from "src/app/shared/services/common.service";
import { JsignalService } from "src/app/shared/services/jsignal.service";
import { LocalStorageSettingsService } from "src/app/shared/services/local-storage-settings.service";
import { ReportingServiceService } from "src/app/shared/services/reporting-service.service";

@Component({
    selector: "app-product-details",
    templateUrl: "./product-details.component.html",
    styleUrls: ["./product-details.component.scss"],
    standalone: false
})
export class ProductDetailsComponent
  implements OnInit, AfterViewInit, OnDestroy, OnChanges
{
  @ViewChild("mainContent", { static: false }) mainContent!: ElementRef;

  @Input() productId: string;
  @Input() external: boolean = false;

  @Output() back = new EventEmitter<void>();

  // productId!: string;
  product: any = null;

  sections = [
    { key: "generalInfo", title: "General Information" },
    { key: "therapyInfo", title: "Therapy Information" },
    { key: "administration", title: "Administration" },
    { key: "literatureInfo", title: "Literature Information" },
    { key: "deviceInfo", title: "Device Information" },
  ];
  sectionVisibility: any = {};
  activeSection = "generalInfo";
  private scrollListener!: () => void;
  //selectedTable;
  responserequest;

  paginationPageSize;

  paginationNumberFormatter;

  rowClassRules;

  lastpage;

  currentpage;

  nextpage;

  nextpageplusone;

  totalpages;

  pagesize;

  gridApi;

  gridColumnApi;

  components;
  rowbindingdata;

  options: any;

  gridOptions = {
    animateRows: true,
    enableSorting: true,
    enableCellChangeFlash: true,
    context: { componentParent: this },
    rowHeight :35
  };

  // Default AG-Grid behaviour
  defaultColDef = {
    resizable: true,
    sortable: true,
    filter: true,
  };

  // Column Definitions
  therapyColumnDefs = [
    { field: "id", headerName: "id", headerTooltip: 'id',tooltipValueGetter: (params) =>'id: ' + params.value, },
    { field: "ProductName", headerName: "Product Name", headerTooltip: 'Product Name',tooltipValueGetter: (params) =>'Product Name: ' + params.value, },
    { field: "moleculeType", headerName: "Molecule Type", headerTooltip: 'Molecule Type',tooltipValueGetter: (params) =>'Molecule Type: ' + params.value, },
    { field: "therapeuticCategory", headerName: "Therapeutic Category", headerTooltip: 'Therapeutic Category',tooltipValueGetter: (params) =>'Therapeutic Category: ' + params.value, },
    { field: "indications", headerName: "Indications", headerTooltip: 'Indications',tooltipValueGetter: (params) =>'Indications: ' + params.value, },
    { field: "description", headerName: "Indication Description", headerTooltip: 'Indication Description',tooltipValueGetter: (params) =>'Indication Description: ' + params.value, },
  ];

  administrationColumnDefs = [
    { field: "id", headerName: "id" , headerTooltip: 'id',tooltipValueGetter: (params) =>'id: ' + params.value, },
    { field: "ProductName", headerName: "Product Name", headerTooltip: 'Product Name',tooltipValueGetter: (params) =>'Product Name: ' + params.value,  },
    { field: "dosageForm", headerName: "Dosage Form", headerTooltip: 'Dosage Form',tooltipValueGetter: (params) =>'Dosage Form: ' + params.value,  },
    { field: "route", headerName: "Route", headerTooltip: 'Route',tooltipValueGetter: (params) =>'Route: ' + params.value,  },
    { field: "countries", headerName: "Approval Countries", headerTooltip: 'Approval Countries',tooltipValueGetter: (params) =>'Approval Countries: ' + params.value,  },
    { field: "expectedAe", headerName: "Expected AE", headerTooltip: 'Expected AE',tooltipValueGetter: (params) =>'Expected AE: ' + params.value,  },
    { field: "specialPopulation", headerName: "Special Populations", headerTooltip: 'Special Populations',tooltipValueGetter: (params) =>'Special Populations: ' + params.value,  },
    { field: "imeList", headerName: "IME List", headerTooltip: 'IME List',tooltipValueGetter: (params) =>'IME List: ' + params.value,  },
    { field: "contraindications", headerName: "Contraindications & Warnings", headerTooltip: 'Contraindications & Warnings',tooltipValueGetter: (params) =>'Contraindications & Warnings: ' + params.value,  },
  ];

  literatureColumnDefs = [
    { field: "id", headerName: "id" , headerTooltip: 'id',tooltipValueGetter: (params) =>'id: ' + params.value,},
    { field: "ProductName", headerName: "Product Name", headerTooltip: 'Product Name',tooltipValueGetter: (params) =>'Product Name: ' + params.value, },
    { field: "sameClass", headerName: "Same In Class", headerTooltip: 'Same In Class',tooltipValueGetter: (params) =>'Same In Class: ' + params.value, },
    { field: "modeAction", headerName: "Mode of Action", headerTooltip: 'Mode of Action',tooltipValueGetter: (params) =>'Mode of Action: ' + params.value, },
    { field: "inclusion", headerName: "Inclusion/Exclusion", headerTooltip: 'Inclusion/Exclusion',tooltipValueGetter: (params) =>'Inclusion/Exclusion: ' + params.value, },
    { field: "reason", headerName: "Reason" , headerTooltip: 'Reason',tooltipValueGetter: (params) =>'Reason: ' + params.value,},
  ];
  // Row Data (filled after mock "API")
  therapyRowData: any[] = [];
  administrationRowData: any[] = [];
  literatureRowData: any[] = [];
  deviceRowData: any[] = [];
  backgroundColorScreen: string;
  buttonColor: string;
  value;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private spinner: NgxUiLoaderService,
    private localStorage: LocalStorageSettingsService,
    private commoService: CommonService,   
    private snackBar: MatSnackBar, 
    private dialog: MatDialog, 
    private fb: FormBuilder,
    private jsignalsService: JsignalService,
    private service: ReportingServiceService,
    private validate: validationmethod,
  ) {}

  // ------------------ COMPONENT INIT ------------------

  ngOnInit(): void {

    this.backgroundColorScreen = this.localStorage.getSettings("ColorD");
    this.buttonColor = this.localStorage.getSettings("ColorA");
    this.paginationPageSize = 3;

    this.sections.forEach(
      (s) => (this.sectionVisibility[s.key] = s.key === "generalInfo")
    );

        if (!this.external) {
        this.route.paramMap.subscribe((params) => {
          this.productId = params.get("productId")!;

          if (this.productId) {
            console.log("Internal mode with productId:", this.productId);
            this.loadProductDetails(this.productId);
          }
        });
      } else if (this.productId) {
        console.log("External mode with productId:", this.productId);
        this.loadProductDetails(this.productId);
      }

    

    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };

    this.rowClassRules = {
      rowBackgroundColor: function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },
    };
  }

  ngAfterViewInit() {
    this.scrollListener = this.updateActiveSection.bind(this);
    this.mainContent.nativeElement.addEventListener(
      "scroll",
      this.scrollListener
    );

    setTimeout(() => this.updateActiveSection(), 100);
  }

  ngOnDestroy() {
    if (this.scrollListener && this.mainContent) {
      this.mainContent.nativeElement.removeEventListener(
        "scroll",
        this.scrollListener
      );
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
  if (
    this.external &&
    changes["productId"] &&
    changes["productId"].currentValue
  ) {
    this.loadProductDetails(changes["productId"].currentValue);
  }
}

  // ------------------ SECTION TOGGLE & SCROLL ------------------

  toggleSection(key: string) {
    this.sectionVisibility[key] = !this.sectionVisibility[key];
  }

  scrollToSection(key: string) {
    const el = document.getElementById(key);
    if (!el) return;

    const container = this.mainContent.nativeElement;
    const containerRect = container.getBoundingClientRect();
    const rect = el.getBoundingClientRect();

    container.scrollTo({
      top: rect.top - containerRect.top + container.scrollTop - 50,
      behavior: "smooth",
    });

    this.activeSection = key;
    this.sectionVisibility[key] = true;
  }

  private updateActiveSection() {
    const container = this.mainContent.nativeElement;
    const containerRect = container.getBoundingClientRect();

    let bestMatch = this.sections[0].key;
    let maxVisible = 0;

    for (let s of this.sections) {
      const el = document.getElementById(s.key);
      if (!el) continue;

      const rect = el.getBoundingClientRect();
      const visibleTop = Math.max(rect.top, containerRect.top);
      const visibleBottom = Math.min(rect.bottom, containerRect.bottom);
      const visibleHeight = Math.max(0, visibleBottom - visibleTop);
      const visibilityRatio = visibleHeight / rect.height;

      if (visibilityRatio > maxVisible) {
        maxVisible = visibilityRatio;
        bestMatch = s.key;
      }
    }

    this.activeSection = bestMatch;
  }

 goBack() {
  if (this.external) {
    this.back.emit();
  } else {
    this.router.navigate(["../../"], { relativeTo: this.route });
  }
}

  // ------------------ MOCK API + PRODUCT MAPPING ------------------

  private safe(v: any) {
    return v === null || v === undefined || v === "" ? "–" : v;
  }

  private loadProductDetails(id: string) {
    console.log("productId:", id);
     this.spinner.start();
    this.jsignalsService.getProductDetailsById(id).subscribe({
      next: (response) => {
        if (response.error === true) {
          this.snackBar.open(response.statusMessage, "Close", {
            duration: 3000,
          });
          this.spinner.stop();
          return;
        }
        this.product = response;
        console.log("Fetched product details:", this.product);
        this.spinner.stop();

      },
      error: (error) => {
        console.error("Error fetching library products:", error);
        this.snackBar.open("Failed to load library products", "Close", {
          duration: 3000,
        });
        this.spinner.stop();
      },
    });

  }

  private getMockBackendData(id: string) {
    return {
      product_id: id,
      product_name: "Crocin Test 1112",
      generic_name: "Acetaminophen",
      inn: "Paracetamol",
      product_group_name: "Pain Relief",
      regulatory_status: "Approved",
      product_type: "Drug",
      internal_code: "P-CROCIN-112",
      dibd: "01 Sep 2007",
      description: "Used for fever and mild pain.",

      molecule_type: ["Small Molecule"],
      therapeutic_category: ["Analgesic"],
      indications: "Fever, headache, body pain",
      indication_desc: "General non-opioid pain management",

      dosage_form: "Tablet",
      route: "Oral",
      approval_countries: ["US", "India", "UK"],
      expected_ae: "Nausea, dizziness",
      special_population: "Pregnant, Elderly",
      ime_list: "Yes",
      contraindications: "Liver issues, alcohol abuse",

      same_class: "Analgesics",
      mode_action: "Inhibits prostaglandin synthesis",
      inclusion_type: "Included",
      reason: "Meets evaluation criteria",

      udi: "UDI-55678",
      device_identifier: "DEV-8877",
      gmdn: "35566",
      umdc: "99887",
      riskClass: "II",
      product_category: "Medical Device",
    };
  }

  private mapProduct(backend: any) {
    this.product = {
      id: this.safe(backend.product_id),
      generalInfo: {
        productGroupName: this.safe(backend.product_group_name),
        regulatoryStatus: this.safe(backend.regulatory_status),
        productType: this.safe(backend.product_type),
        internalCode: this.safe(backend.internal_code),
        genericName: this.safe(backend.generic_name),
        inn: this.safe(backend.inn),
        brandName: this.safe(backend.product_name),
        dibd: this.safe(backend.dibd),
        description: this.safe(backend.description),
      },
      therapyInfo: {
        id:backend.product_id || [],
        ProductName:backend.product_name || [],
        moleculeType: backend.molecule_type || [],
        therapeuticCategory: backend.therapeutic_category || [],
        indications: this.safe(backend.indications),
        indicationDescription: this.safe(backend.indication_desc),
      },
      administration: {
        id:backend.product_id || [],
        ProductName:backend.product_name || [],
        dosageForm: this.safe(backend.dosage_form),
        route: this.safe(backend.route),
        approvalCountries: backend.approval_countries || [],
        expectedAe: this.safe(backend.expected_ae),
        specialPopulation: this.safe(backend.special_population),
        imeList: this.safe(backend.ime_list),
        contraindications: this.safe(backend.contraindications),
      },
      literature: {
        id:backend.product_id || [],
        ProductName:backend.product_name || [],
        sameClass: this.safe(backend.same_class),
        modeAction: this.safe(backend.mode_action),
        inclusionType: this.safe(backend.inclusion_type),
        reason: this.safe(backend.reason),
      },
      deviceInfo: {
        udi: this.safe(backend.udi),
        deviceIdentifier: this.safe(backend.device_identifier),
        gmdn: this.safe(backend.gmdn),
        umdc: this.safe(backend.umdc),
        riskClass: this.safe(backend.risk_class),
        productCategory: this.safe(backend.product_category),
      },
    };
  }

  // ------------------ GRID POPULATION ------------------

  private loadAllGrids() {
    this.therapyRowData = [
      {
        id : this.product.therapyInfo.id,
        ProductName:this.product.therapyInfo.ProductName,
        moleculeType: this.product.therapyInfo.moleculeType.join(", "),
        therapeuticCategory:this.product.therapyInfo.therapeuticCategory.join(", "),
        indications: this.product.therapyInfo.indications,
        description: this.product.therapyInfo.indicationDescription,
      },
    ];

    this.administrationRowData = [
      {
        id : this.product.administration.id,
        ProductName:this.product.administration.ProductName,
        dosageForm: this.product.administration.dosageForm,
        route: this.product.administration.route,
        countries: this.product.administration.approvalCountries.join(", "),
        expectedAe: this.product.administration.expectedAe,
        specialPopulation: this.product.administration.specialPopulation,
        imeList: this.product.administration.imeList,
        contraindications: this.product.administration.contraindications,
      },
    ];

    this.literatureRowData = [
      {
        id : this.product.literature.id,
        ProductName:this.product.literature.ProductName,
        sameClass: this.product.literature.sameClass,
        modeAction: this.product.literature.modeAction,
        inclusion: this.product.literature.inclusionType,
        reason: this.product.literature.reason,
      },
        {
                id : this.product.literature.id,
        ProductName:this.product.literature.ProductName,  
        sameClass: this.product.literature.sameClass,
        modeAction: this.product.literature.modeAction,
        inclusion: this.product.literature.inclusionType,
        reason: this.product.literature.reason,
      },
            {
                      id : this.product.literature.id,
        ProductName:this.product.literature.ProductName,
        sameClass: this.product.literature.sameClass,
        modeAction: this.product.literature.modeAction,
        inclusion: this.product.literature.inclusionType,
        reason: this.product.literature.reason,
      },
    ];

    this.deviceRowData = [
      {
        udi: this.product.deviceInfo.udi,
        deviceIdentifier: this.product.deviceInfo.deviceIdentifier,
        gmdn: this.product.deviceInfo.gmdn,
        umdc: this.product.deviceInfo.umdc,
        riskClass: this.product.deviceInfo.riskClass,
        productCategory: this.product.deviceInfo.productCategory,
      },
    ];
  }
  onLiteratureGridReady(params) {
    this.rowbindingdata = params;
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    // this.spinner.start()
    // Expand all rows
    //  params.api.expandAll();
    // this.service.retrieveReportTemplatesByDnsId().subscribe(response=>{

    //   console.log(response);

    //   if (response.error == true) {

    //     this.spinner.stop();

    //     this.snackbar.open(response.statusMessage, 'OK', {duration: 5000});

    //   } else {

    //     this.spinner.stop();
    this.gridApi.setGridOption('rowData', this.literatureRowData);

    //   }
    // })
  }
  onAdminstartionGridReady(params) {
    this.rowbindingdata = params;
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.setGridOption('rowData', this.administrationRowData);
  }
onTherapyGridReady(params) {
    this.rowbindingdata = params;
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.setGridOption('rowData', this.therapyRowData);
  }
}

